
import React, {  Suspense } from 'react';
import { Routes, Route ,BrowserRouter} from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
// import TravelMagazine from './pages/MagazinTravel/TravelMagazine';
// import Destinations from './pages/Destination/Destinations';
// import DestinationDetail from './pages/DestinationDetails/DestinationDetail';
// import PackageDetail from './pages/PackageDetails/PackageDetail';
import SuccessPage from './pages/SuccessPage';
import Policy from './components/Policy';
// import ArticleDynamic from './pages/ArticleDynamic';
import Parcode from './pages/Parcode';
import ScrollToTop from './components/ScrollToTop';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/ContactUs/ContactUs';
import VisaRequirements from "./pages/VisaRequirements/VisaRequirements"; // استدعاء الصفحة الجديدة
import AppRoutesTracker from "./AppRoutesTracker"; // ✅ تتبّع تغيّر الصفحات
import TradeRegister from './pages/TradeRegister';
import TourismLicense from "./pages/TourismLicense";
import LandingAds from "./pages/LandingAds/LandingAds";
import SupportComplaints from './pages/SupportComplaints/SupportComplaints';
import CancellationPolicy from './pages/CancellationPolicy/CancellationPolicy';

function App() {
  return (
    <BrowserRouter>
     <AppRoutesTracker />
      <Suspense fallback={<div className="text-center py-5">...جاري التحميل</div>}>
        <ScrollToTop />
        <Routes>
          <Route path="/lp/offer" element={<LandingAds />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="contact" element={<ContactUs />} />
                <Route path="support-complaints" element={<SupportComplaints />} />
            <Route path="cancellation-policy" element={<CancellationPolicy />} />
            {/*<Route path="magazine" element={<TravelMagazine />} />
            <Route path="destinations" element={<Destinations />} />
            <Route path="destinations/:slug" element={<DestinationDetail />} />
            <Route path="destinations/:destinationSlug/package/:packageName" element={<PackageDetail />} />
            <Route path="/magazine/article/:slug" element={<ArticleDynamic />} />*/}
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="parcode" element={<Parcode />} />
            <Route path="/visa-requirements" element={<VisaRequirements />} />
            <Route path="/trade-register" element={< TradeRegister/>} />
            <Route path="/tourismlicense" element={<TourismLicense />} />

          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
